<template>
  <v-layout
    wrap
    justify-end
  >
    <v-flex shrink>
      <displays-text
        color="grey"
        type="headline"
        :text="title"
      />
    </v-flex>
    <v-spacer />
    <slot />
  </v-layout>
</template>

<script>
import DisplaysText from 'Support/components/DisplaysText.vue';

export default {
  name: 'FormGroup',
  components: {
    DisplaysText,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
